export class DeviceFeatureDetection {
    /**
     * The device supports touch, does it have a touchscreen
     */
    public get isTouch() {
        return (
            ('ontouchstart' in window)
            || ((window as any).DocumentTouch && document instanceof (window as any).DocumentTouch)
            || (window.navigator.maxTouchPoints !== undefined && window.navigator.maxTouchPoints > 0)
        );
    }
}
